import { Service } from "@/api";

export function getStaffRecruitInfo(params) {
    return Service({
        url: 'api/websiteAdvert',
        params
    })
}

export default { getStaffRecruitInfo }